export default __webpack_public_path__ + "static/media/note-text-outline.773e425d.svg";